<script setup>
  import { onMounted } from 'vue'

  onMounted(() => {
    // ブラウザバックを無効化
    history.pushState(null, '', location.href)
    window.addEventListener('popstate', () => {
      history.pushState(null, '', location.href)
    })
  })
</script>
<style lang="less" scoped>
  .complete-main {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #f5f5f5;
    color: var(--text-color);
  }

  .title {
    margin-bottom: 20px;
    text-align: center;
    font-size: 18px;
  }

  .content {
    text-align: center;
    line-height: 1.5;
  }
</style>
<template>
  <main class="complete-main">
    <div class="complete-container">
      <h1><img class="logo" src="@/assets/img/login_logo.svg" alt="ディーモ for 社労士" /></h1>
      <div class="message-content">
        <p class="title">確認メールを送信しました</p>

        <div class="content">
          <p>ご登録ありがとうございます。</p>
          <p>メール内のリンクをクリックして、登録を完了してください。</p>
          <p>
            メールが届かない場合は、迷惑メールフォルダをご確認いただくか、
            <br />
            別のメールアドレスで再度お試しください。
          </p>
        </div>
      </div>
    </div>
  </main>
</template>
